import React from 'react';
        import { useSelector } from "react-redux";


        export const CustomHeader = (props) => {
            const { productSort } = useSelector((s) => s.products);
            const { tagSort } = useSelector((s) => s.tags);
            const { contactSort } = useSelector((s) => s.contacts);
            const { titleSort } = useSelector((s) => s.titles);
            const { sectionSort } = useSelector((s) => s.sharedSections);
            const { commentSort } = useSelector((s) => s.comments);
            const { sortParam } = useSelector((s) => s.linkedProducts);

            const { colId, page, displayName, setSort } = props;

            // Map page to sort state
            const sortMap = {
                products: productSort,
                tags: tagSort,
                contacts: contactSort,
                titles: titleSort,
                sections: sectionSort,
                comments: commentSort,
                linkedProducts: sortParam
            };

            const sortState = sortMap[page] || [];
            const sortedColId = sortState[0];
           const sortDirection = (sortState[1] || 'asc').toLowerCase();

            const isActive = colId === sortedColId;

            const handleSort = () => {
                if (!isActive) {
                    setSort(colId, 'asc');
                } else {
                    setSort(colId, sortDirection === 'asc' ? 'desc' : 'asc');
                }
            };

            const buttonStyle = {
                fontSize: '0.85rem',
                padding: '0.25rem 0.5rem',
                cursor: 'pointer',
                marginLeft: '0.25rem',
                fontWeight: isActive ? 'bold' : 'normal',
                background: 'none',
                border: 'none',
                display: 'flex',
                alignItems: 'center',
            };

            return (
                <button style={buttonStyle} onClick={handleSort}>
                    {displayName}
                    {isActive ? (sortDirection === 'desc' ? '↓' : '↑') : ''}
                </button>
            );
        };